// @core/api/endpoints/product/delete_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/product';

/**
 * Delete product
 * Permanently removes a product from the platform. This operation will fail if there are active subscriptions to the product.
 */
export async function DeleteProduct(
  product_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
